export const admZubPth = 'admin-lOp5vNyX3sIzqA2'
